import React from 'react'
import i18n from 'live/services/i18n'
import liveUiService from 'live/services/ui'
import { LiveApi } from 'live/lib/api'
import AddOnImpl from 'live/api/add-on'
import { LIVE_PERMISSIONS } from 'live/services/authorization'
import ParametersButton from './components/ParametersButton'
import ParametersEditionButton from './components/ParametersEditionButton'
import RunParametersDefaultConfig from './components/RunParametersDefaultConfig'

try {
    LiveApi.Extension.configuration.entries.register({
        name: i18n('Run Parameters Default'),
        area: 'run-parameters-default-settings',
        group: 'static-data',
        url: '/#/config/run-parameters-default-settings',
        component: props => (<RunParametersDefaultConfig/>),
        permissions: [LIVE_PERMISSIONS.ADMIN]
    })

    liveUiService.registerAddOn(
        liveUiService.uiSections.DASHBOARD_EDITION_MAIN_HEADER,
        new AddOnImpl(() => ParametersEditionButton(), { order: 4 })
    )

    let plugin = ['plugin-header-navigation']
    fetch('/rest/plugin')
        .then(r => r.json())
        .then(r => {
            let pluginHeaderNavigationDetected =
                r.data.filter(e => plugin.indexOf(e.name) > -1 && e.status.status === 'VALID').length > 0

            pluginHeaderNavigationDetected
                ? liveUiService.registerAddOn(
                    liveUiService.uiSections.DASHBOARD_VIEW_UNDER_HEADER,
                    new AddOnImpl(() => ParametersButton(pluginHeaderNavigationDetected), { order: 1 })
                )
                : liveUiService.registerAddOn(
                    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER,
                    new AddOnImpl(() => ParametersButton(pluginHeaderNavigationDetected), { order: -20 })
                )
        })

} catch (e) {
    console.error(e)
}